<div class='root' *ngIf='startApp'>
  <cloud-cost-calculation-tool-header class='base-header'></cloud-cost-calculation-tool-header>
  <cloud-cost-calculation-tool-story-toast></cloud-cost-calculation-tool-story-toast>
  <div class='router-content'>
    <router-outlet></router-outlet>
  </div>
</div>
